module.exports = __webpack_public_path__ + "static/media/ic_hs_special_benefits.be7e3561.svg";